<template>
  <div>
    <span>
      <b-button v-on:click="detailOne()" size="sm" variant="outline-light">
        <Icon
          :icon="params.iconDetailOne"
          width="20"
          height="20"
          :color="params.iconColorOne"
          v-b-tooltip.hover.bottom="$t(params.tooltipOne)"
        />
      </b-button>
    </span>
    <span>
      <b-button v-on:click="detailTwo()" size="sm" variant="outline-light">
        <Icon
          :icon="params.iconDetailTwo"
          width="20"
          height="20"
          :color="params.iconColorTwo"
          v-b-tooltip.hover.bottom="$t(params.tooltipTwo)"
        />
      </b-button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  props: [
    "detailMethodsOne",
    "tooltipOne",
    "iconDetailOne",
    "iconColorOne",
    "isParam",
    "detailMethodsTwo",
    "tooltipTwo",
    "iconDetailTwo",
    "iconColorTwo",
  ],
  components: { Icon },
  methods: {
    detailOne() { 
      if (this.params.isParam == "true")
        this.$root.$emit(this.params.detailMethodsOne, this.params);
      else this.$root.$emit(this.params.detailMethodsOne, this.params.data);
    },
    detailTwo() {
      this.$root.$emit(this.params.detailMethodsTwo, this.params.data);
    },
  },
};
</script>
